export function baseAuthURL () {
  return process.env.VUE_APP_API_SUIT_URL;
}

export function baseURLVertical () {
  return process.env.VUE_APP_URL_VERTICAL;
}

export function baseURLCookie () {
  return process.env.VUE_APP_COOKIE_DOMAIN;
}

export function isDebugMode () {
  return process.env.NODE_ENV !== 'production';
}

export function baseURLDinapsis () {
  return process.env.VUE_APP_DINAPSIS_URL;
}

export function maxFileSizeVideo () {
  return parseInt(process.env.VUE_APP_MAX_FILE_SIZE_VIDEO);
}

export function isAuthIn (state) {
  if (state.authStatus !== 'success') return false;
  return true;
}

export function userMail (state) {
  if (state.user.email === undefined) return '';
  return state.user.email;
}

export function fullName (state) {
  if (state.user.given_name === undefined) return '';
  return state.user.given_name + ' ' + state.user.family_name;
}

export function isSuperAdmin (state) {
  return state.user.role ? state.user.role.includes('superadmin') : false;
}

export function isAdmin (state) {
  return state.user.role ? state.user.role.includes('admin') : false;
}

export function isAdminEntidad (state) {
  return state.isAdminEntidad ?? false;
}

export function haveAccess (state, getters) {
  // Have access or is an internal user
  return state.user.role ? state.user.role.includes('access') || !getters.isExternal : false;
}

export function isExternal (state) {
  return state.user.isExternal;
}

export function userId (state) {
  return state.user.nameid;
}

export function userData (state) {
  return state.user;
}

export function isLoggedIn (state) {
  if (state.user.aud == null) return false;
  return state.isLoggedIn;
}

export function isSideBarMenuOpen (state) {
  return state.sideBarmenuIsOpen ? state.sideBarmenuIsOpen : false;
}

export function haveEntidadesVisibles (state) {
  return state.entidadesVisibles;
}

export function haveEntidadesVisiblesRelated (state) {
  return state.entidadesVisiblesRelated;
}

export function isDeliveryUser (state) {
  return state.isDeliveryUser ?? false;
}
